export const url = {
    home: () => '/',

    catalog: () => '/packages',

    category: (category) => `/packages/${category.slug}`,

    product: (product) => `/shop/products/${product.slug}`,
};

export function getCategoryParents(category) {
    return category.parent ? [...getCategoryParents(category.parent), category.parent] : [];
}
